export default __webpack_public_path__ + "static/media/handle.37087b9d.obj";